export interface IClientException {
	name: string;
	message: string;
	userAgent: string;
	url: string;
	moduleName: string;
	username?: string;
	stackTrace?: string;
}

export class ClientException implements IClientException {
	name: string;
	message: string;
	userAgent: string;
	url: string;
	moduleName: string;
	username?: string;
	stackTrace?: string;
}
